import { connect } from 'react-redux';
import {
  hasIuliAdminAccess,
  isKnownIuliAdminFeature,
} from './utils/iuliAdminAccess';

const PermissionGate = ({
  children,
  permissions,
  currentPermissions,
  currentUser,
}) => {
  if (permissions === 'public') {
    return children;
  }
  if (permissions === 'isIuliAdmin') {
    if (currentUser.is_iuli_admin) {
      return children;
    }
    return null;
  }

  // Normalize permissions to array
  const permsArray = Array.isArray(permissions) ? permissions : [permissions];

  if (permsArray.some(isKnownIuliAdminFeature)) {
    if (permsArray.some((perm) => hasIuliAdminAccess(currentUser, perm))) {
      return children;
    }
    return null;
  }

  // Check if user has any of the required permissions
  const hasPermission = (currentPermissions || []).some(({ name }) =>
    permsArray.some((perm) => name.includes(perm))
  );
  if (hasPermission || currentUser.is_iuli_admin) {
    return children;
  }
  return null;
};

const mapStateToProps = (state) => ({
  currentPermissions: state.permissions.currentPermissions,
  currentUser: state.auth?.login?.values?.loggedInUser,
});

export default connect(mapStateToProps)(PermissionGate);
